import type { Localized } from './i18n';

export interface Work {
  id: string;
  title: Localized;
  description?: Localized;
  cluster: string;
  aspect: number; // width / height
  palette: string[]; // 1–3 hex colors, dominant first
  year: number;
  ext: string; // original extension; 'gif' → animated detail view
}

export interface Manifest {
  generatedAt: string;
  clusters: string[]; // ordered, 'wystawa' first when present
  works: Work[];
}

export async function loadManifest(): Promise<Manifest> {
  const res = await fetch(`${import.meta.env.BASE_URL}data/manifest.json`);
  if (!res.ok) throw new Error(`manifest load failed: ${res.status}`);
  return res.json();
}
